// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-tab-link {
  min-width: max-content;
}

.tgpp-profile {
  color: white;
  font-size: 30px;
}

.tgpp-logout-icon {
  margin: 2px 10px 0 10px;
  color: #c00;
}

.tgpp-username {
  color: white;
}

.tgpp-profile-avatar {
  margin: 0 20px 0 0;
  cursor: pointer;
}

[data-letters]:before {
  content: attr(data-letters);
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8705882353);
  vertical-align: middle;
  margin-right: 10px;
  color: #616161;
  margin-bottom: 0;
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/component/tab-menu/tab-menu.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AACF","sourcesContent":[".mat-mdc-tab-link {\n  min-width: max-content;\n}\n\n.tgpp-profile {\n  color: white;\n  font-size: 30px;\n}\n\n.tgpp-logout-icon {\n  margin: 2px 10px 0 10px;\n  color: #c00;\n}\n\n.tgpp-username {\n  color: white;\n}\n\n.tgpp-profile-avatar {\n  margin: 0 20px 0 0;\n  cursor: pointer;\n}\n\n[data-letters]:before {\n  content: attr(data-letters);\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  border-radius: 50%;\n  background: #ffffffde;\n  vertical-align: middle;\n  margin-right: 10px;\n  color: #616161;\n  margin-bottom: 0;\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
